module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/solution_img_01-e711c326703a815e8bca71358aa98ea3.png";